import {PhoneHQAvatar, PhoneHQIconAvatar, PhoneHQGlyph, StatusBadge, PhoneHQInput, PhoneHQSelect, PhoneHQButton, PhoneHQConfirmDialog, PhoneHQModal} from 'ch3-ui-lib';
import {useEffect, useState} from "react";
import useMediaQuery from "../../utilis/screenWidthUtils.ts";
import {useSelector} from "react-redux";
import {Link, useNavigate, useParams} from "react-router-dom";
import {Colors, selectorItem} from "../../utilis/types/Types";

import {Controller, useFieldArray, useForm} from "react-hook-form";
import type {FieldErrors} from "react-hook-form";
import AddUserNumberModal from "../Groups/AddUserNumberModal.tsx";
import {useFetchMsisdnsAdminQuery} from "../../store/features/MsisdnSettings/msisdnSettingsService.ts";
import {useFetchGroupsAdminQuery} from "../../store/features/groups/groupsService.ts";
import {selectUserId} from "../../store/features/Auth/authSlice.ts";
import {Msisdn} from "../../store/features/Msisdns/msisdnService.ts";
import {
    useAssignUserToGroupMutation,
    useAssignUserToPhoneNumberMutation,
    useCreateUserMutation,
    useDeleteUserMutation,
    useEnableUserMutation,
    useGetGroupForUserQuery,
    useGetPhoneNumbersForUserQuery,
    useGetUserByIdQuery,
    UserFormData,
    UserRole,
    useUpdateUserMutation
} from "../../store/features/Users/userService.ts";
import google from "../../assets/google.svg";
import {useAppDispatch} from "../../store/store.ts";
import {showToast} from "../../store/features/Notifications/notificationsSlice.tsx";
import {validateEmail, validatePersonName} from "../../utilis/commonValidators.ts";
import AdminPanelRestrictedView from "../../components/AdminPanelRestrictedView/AdminPanelRestrictedView";

interface TeamDetailsAdminProps {
    admin?: boolean;
}

export default function TeamDetailsAdmin({ admin = true }: TeamDetailsAdminProps) {

    const dispatch = useAppDispatch();

    const { id } = useParams<{ id: string }>();
    const isMobile = useMediaQuery('(max-width: 960px)');
    const isNewUser = id == 'new';
    const userId = useSelector(selectUserId);
    const [openDialog, setOpenDialog] = useState<null | 'groups' | 'numbers' | 'deactivate' | 'activate'>(null);
    const navigate = useNavigate();

    const [phoneNumbersToAdd, setPhoneNumbersToAdd] = useState<selectorItem[]>([]);
    const [groupsToAdd, setGroupsToAdd] = useState<selectorItem[]>([]);
    const role = useSelector((state: any) => state.auth.role);

    const {
        control,
        handleSubmit,
        setValue,
        watch,
        clearErrors,
        formState: { errors },
    } = useForm<UserFormData>();

    const { fields: phoneNumbersArray } = useFieldArray({
        control,
        name: 'phoneNumbers',
    });

    const { fields: groupsArray } = useFieldArray({
        control,
        name: 'groups',
    });


    const { data: usersData } = useGetUserByIdQuery({ id });
    const { data: assignedGroups } = useGetGroupForUserQuery({ userId:id });
    const { data: assignedMsisdns } = useGetPhoneNumbersForUserQuery({ userId:id });
    const { data: groupsData } = useFetchGroupsAdminQuery({ userId, limit: 1000 });
    const { data: msisdnsData } = useFetchMsisdnsAdminQuery({ phrase: '' });
    const [assignUserToGroup] = useAssignUserToGroupMutation();
    const [assignUserToMsisdn] = useAssignUserToPhoneNumberMutation();
    const [createUser] = useCreateUserMutation();
    const [updateUser] = useUpdateUserMutation();
    const [disableUser] = useDeleteUserMutation();
    const [enableUser] = useEnableUserMutation();

    const publicNumbers = msisdnsData?.data.filter((item) => item.assigmentScope !== 'PRIVATE');


    const mapMsisdns = (msisdns: any) => {
        return msisdns.map((msisdn: any) => ({
            key: msisdn.msisdnId,
            label: msisdn.label,
            value: msisdn,
            prefixElement: (
                <PhoneHQIconAvatar icon={msisdn.icon} color={msisdn.iconColor} size="24px"/>
            )
        }));
    }
    const msisdnsList: selectorItem[] = publicNumbers? mapMsisdns(publicNumbers) : [];
    const selectedMsisdns = mapMsisdns(phoneNumbersArray);

    const mapGroups = (groups: any) => {
        return groups.map((group: any) => ({
            key: group?.groupId,
            label: group?.name,
            value: group,
            prefixElement: (
                <div>
                    <PhoneHQIconAvatar icon={group?.icon} color={group?.iconColor ?? 'auto'} size="24px"/>
                </div>
            ),
            type: 'checkbox'
        }));
    }
    const groupsList = groupsData?.groups ? mapGroups(groupsData.groups?.map((group) => group?.group)): [];
    const selectedGroups = mapGroups(groupsArray);

    const dropdownOptions = [
        { label: 'Admin', value: 'ADMIN' },
        { label: 'User', value: 'USER' },
    ];


    

    useEffect(() => {
        if (usersData) {
            setValue('firstName', usersData.firstName);
            setValue('lastName', usersData.lastName);
            setValue('email', usersData.email);
            setValue('phoneNumbers', assignedMsisdns ?? []);
            setValue('groups', assignedGroups);
            setValue('position', usersData.position);
            setValue('role', usersData.role);
        }
    }, [usersData, assignedMsisdns, assignedGroups, setValue]);



    const handleAddGroups = (confirmed: boolean) => {
        if (confirmed) {
            setValue('groups', groupsToAdd.map((group: selectorItem) => group.value));
        }
    };
    const handleAddPhoneNumbers = (confirmed: boolean) => {
        if (confirmed ) {
            setValue('phoneNumbers', phoneNumbersToAdd.map((phoneNumber: selectorItem) => phoneNumber.value));
        }
    };
    
    const deactivateUser = async (res: boolean) => {
        if (res) {
            try {
                await disableUser({id});
                dispatch(showToast({description: 'User successfully deactivated', type: 'success'}));
            } catch (error) {
                dispatch(showToast({description: 'Error deactivating user', type: 'error'}));
            }
        }
    }
    const activateUser = async (res: boolean) => {
        if (res) {
            try {
                await enableUser({id});
                dispatch(showToast({description: 'User successfully activated', type: 'success'}));
            }
            catch (error) {
               dispatch(showToast({description: 'Error activating user', type: 'error'}));
            }


        }
    }

    const handleGroupMsisdnCheck = (
        currentGroups: any[],
        newGroups: any[],
        currentPhoneNumbers: any[]
    ) => {
        const currentGroupIds = currentGroups.map(group => group.groupId);
        const newGroupIds = newGroups.map(group => group.groupId);

        const removedGroupIds = currentGroupIds.filter(id => !newGroupIds.includes(id));

        if (removedGroupIds.length === 0) {
            return currentPhoneNumbers.map(phone => phone.msisdnId);
        }

        let msisdnsToRemove: number[] = [];

        removedGroupIds.forEach(groupId => {
            const group = groupsData?.groups.find(g => g.group.groupId === groupId);
            if (group && group.msisdns && group.msisdns.length > 0) {
                const groupMsisdnIds = group.msisdns.map((msisdn: any) => msisdn.msisdnId);
                msisdnsToRemove = [...msisdnsToRemove, ...groupMsisdnIds];
            }
        });

        return currentPhoneNumbers
            .filter(phone => !msisdnsToRemove.includes(phone.msisdnId))
            .map(phone => phone.msisdnId);
    };

    const handleValidationErrors = (formErrors: FieldErrors<UserFormData>) => {
        const errorMessages = [
            formErrors.firstName?.message,
            formErrors.lastName?.message,
            formErrors.email?.message,
            formErrors.role?.message,
        ].filter(Boolean);
        const errorMessage = errorMessages.length
            ? errorMessages.join('. ')
            : 'Please fix the highlighted fields';

        dispatch(showToast({description: String(errorMessage), type: 'error'}));
    };

    const onSubmit = async (data: UserFormData) => {
        if (isNewUser) {
            const { groups, phoneNumbers, ...userData } = data;
            try {
                const newUser = await createUser({userData}).unwrap();
                if (groups && groups.length > 0) {
                    await assignUserToGroup({
                        userId: newUser.userId,
                        groupIds: groups.map((group: any) => group.groupId)
                    });
                }
                if (phoneNumbers && phoneNumbers.length > 0) {
                    await assignUserToMsisdn({
                        userId: newUser.userId,
                        phoneNumberIds: phoneNumbersArray.map((phoneNumber: any) => phoneNumber.msisdnId)
                    });
                }

                navigate('/admin/team');
            } catch (error) {
                console.error("Error creating user:", error);
            }
        } else {
            try {
                const { groups, phoneNumbers, ...userData } = data;
                await updateUser({userData, userId: id}).unwrap();

                const currentGroups = assignedGroups || [];
                const currentPhoneNumbers = phoneNumbers || [];
                const newGroups = groups || [];

                const updatedPhoneNumberIds = handleGroupMsisdnCheck(
                    currentGroups,
                    newGroups,
                    currentPhoneNumbers
                );
                await assignUserToGroup({
                    userId: id,
                    groupIds: groups ? groups.map((group: any) => group.groupId) : []
                });

                await assignUserToMsisdn({
                    userId: id,
                    phoneNumberIds: updatedPhoneNumberIds
                });

                navigate('/admin/team');
            } catch (error) {
                console.error("Error updating user:", error);
                dispatch(showToast({description: 'Error updating user', type: 'error'}));
            }
        }
    };

    const addPhoneNumberModal = (
        <AddUserNumberModal
            type="PHONE_NUMBERS"
            data={selectedMsisdns}
            msisdns={msisdnsList}
            setData={setPhoneNumbersToAdd}
        />
    );

    const addGroupsModal = (
        <AddUserNumberModal
            type="GROUPS"
            data={selectedGroups}
            groups={groupsList}
            setData={setGroupsToAdd}
        />
    );


    const managePhoneNumbersTrigger = (
        <PhoneHQButton variant="secondary" size="sm" disabled={usersData?.status === "DELETED"} onClick={() => setOpenDialog('numbers')} className="mr-6 w-[160px] " phq-id='teamAdmin-managePhoneNumbersTriggerBtn' ><PhoneHQGlyph name='settings' size={16}/>Manage access</PhoneHQButton>
    );

    const manageGroupsTrigger = (
        <PhoneHQButton variant="secondary" size="sm" disabled={usersData?.status === "DELETED"} onClick={() => setOpenDialog('groups')} className="mr-6 w-[160px]" phq-id='teamAdmin-manageGroupsTriggerBtn' ><PhoneHQGlyph name='settings' size={16}/>Manage access</PhoneHQButton>
    );

    if (!usersData && !isNewUser) {
        return <div>Loading user data...</div>;
    }


    return (
        <>
                {Boolean(role === 'USER') &&
                    <AdminPanelRestrictedView></AdminPanelRestrictedView>
                }
                {Boolean(role !== 'USER') &&
            <div className="w-full">
                <div className="h-[calc(100vh-var(--header-height))]  overflow-y-auto">
                    <div className={isMobile ? 'px-4' : ''}>
                        {/* Header section with user details */}
                        {!isNewUser ? (
                            <div className="justify-start items-center flex py-5 px-8 border-b border-line">
                                <PhoneHQAvatar className="rounded" src={usersData.avatarUrl} name={`${usersData.firstName} ${usersData.lastName}`} size="64px"/>

                                {usersData.externalAssociationDetails && <img src={google} alt="Google"
                                      className="w-6 h-6 inline relative right-4 top-6 rounded-full bg-surface p-[2px]"/>}
                                <div className={"flex-col justify-start gap-2 flex " + (!usersData.externalAssociationDetails ? 'ml-4' : ' ml-[-8px]')}>
                                    <div className="text-2xl font-semibold leading-7 ">
                                        {`${usersData.firstName} ${usersData.lastName}`}
                                        {usersData.externalAssociationDetails &&  <span className={'ml-2'}>
                                            <img src={google} alt="Google" className="w-6 h-6 inline"/>
                                        </span> }
                                    </div>
                                    <div
                                        className="text-md text-ink-secondary "><span className={'capitalize'}>{usersData.role.toLowerCase()} </span>
                                        {(usersData.status === "DELETED" ) && <span className={'ml-2'}>
                                            <StatusBadge tone="neutral">Deactivated account</StatusBadge>
                                        </span>}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="flex justify-between items-center py-5 px-8 border-b border-line h-[61px]">
                                <h5 className='font-semibold text-ink'>New team member</h5>
                            </div>

                        )}

                        <div className="w-full overflow-y-scroll">
                            {/* General information section */}
                            <div className={`flex border-b ${isMobile ? 'mt-6' : ''} border-line`}>
                                <div className="border-r border-line px-8 py-5 lg:min-w-[180px] lg:w-[180px] xl:min-w-[280px] 2xl:min-w-[345px]">
                                    <div className="font-semibold text-lg">
                                        General information
                                    </div>
                                    {(admin) && Boolean(!usersData?.externalAssociationDetails)  && (
                                        <div className="text-ink-muted text-sm">
                                            Update name and general information.
                                        </div>
                                    )}
                                </div>

                                <div className="flex flex-col w-full">
                                    {/* First name and last name */}
                                    <div className="px-6 py-4 w-full flex gap-6 justify-between">
                                        <div className="w-[40%]">
                                            <Controller
                                                name="firstName"
                                                control={control}
                                                rules={{
                                                    required: 'First name is required',
                                                    validate: {
                                                        isValid: (value: string) => validatePersonName(value) || 'First name contains invalid characters',
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <PhoneHQInput
                                                    phq-id='teamAdmin-nameInput' 
                                                        containerClassName="py-3 max-w-full"
                                                        label="First name"
                                                        {...field}
                                                        disabled={Boolean(usersData?.externalAssociationDetails || usersData?.status === "DELETED")}
                                                        value={field.value}
                                                        onChange={({target: {value}}) => field.onChange(value)}
                                                        error={errors.firstName?.message}
                                                        placeholder="Enter first name"
                                                    />
                                                )}
                                            />
                                        </div>
                                        <div className="w-[47%]">
                                            <Controller
                                                name="lastName"
                                                control={control}
                                                rules={{
                                                    required: 'Last name is required',
                                                    validate: {
                                                        isValid: (value: string) => validatePersonName(value) || 'Last name contains invalid characters',
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <PhoneHQInput
                                                    phq-id='teamAdmin-lastNameInput' 
                                                        {...field}
                                                        value={field.value}
                                                        disabled={Boolean(usersData?.externalAssociationDetails || usersData?.status === "DELETED")}
                                                        onChange={({target: {value}}) => field.onChange(value)}
                                                        error={errors.lastName?.message}
                                                        placeholder="Enter last name"
                                                        containerClassName="max-w-full py-3 pr-4"
                                                        label="Last name"
                                                    />
                                                )}
                                            />
                                        </div>

                                    </div>

                                    {/* Email */}
                                    <div className="px-6 py-4">
                                        <Controller
                                            name="email"
                                            control={control}
                                            rules={{
                                                required: 'Email is required',
                                                validate: {
                                                    isValid: (value: any) => value ? (validateEmail(value) || 'Invalid email format') : true,
                                                },
                                            }}
                                            render={({ field }) => (
                                                <PhoneHQInput
                                                phq-id='teamAdmin-emailInput' 
                                                    {...field}
                                                    value={field.value}
                                                    disabled={Boolean(usersData?.externalAssociationDetails || usersData?.status === "DELETED")}
                                                    onChange={({target: {value}}) => field.onChange(value)}
                                                    error={errors.email?.message}
                                                    placeholder="Enter email address"
                                                    containerClassName="max-w-full py-3 pr-4"
                                                    label="Email address"
                                                />
                                            )}
                                        />
                                    </div>


                                    {/* Position */}
                                    <div className="px-6 py-4">
                                        <Controller
                                            name="position"
                                            control={control}
                                            render={({ field }) => (
                                                <PhoneHQInput
                                                phq-id='teamAdmin-positionInput' 
                                                    {...field}
                                                    disabled={Boolean(usersData?.externalAssociationDetails || usersData?.status === "DELETED")}
                                                    value={field.value}
                                                    onChange={({target: {value}}) => field.onChange(value)}
                                                    placeholder="Enter position"
                                                    containerClassName="max-w-full py-3 pr-4"
                                                    label="Position"
                                                />
                                            )}
                                        />
                                    </div>


                                    {/* Role */}
                                    <div className="px-6 py-4">
                                        <label className='text-sm flex items-center gap-1'>
                                            Role
                                        </label>
                                        <Controller
                                            name="role"
                                            control={control}
                                            rules={{ required: 'Role is required' }}
                                            render={({ field }) => (
                                                <PhoneHQSelect
                                                    aria-label="Role"
                                                    value={field.value}
                                                    onChange={(value) => {
                                                        setValue('role', value as UserRole);
                                                        clearErrors('role');
                                                    }}
                                                    options={dropdownOptions}
                                                    placeholder="Select role"
                                                    disabled={Boolean(usersData?.status === "DELETED")}
                                                    error={errors.role?.message}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>


                            {/* Groups section */}
                            <div className={`flex border-b ${isMobile ? 'mt-6' : ''} border-line`}>
                                <div className="border-r border-line px-8 py-5 lg:min-w-[180px]  lg:w-[180px] xl:min-w-[280px] 2xl:min-w-[345px]">

                                    <div className="font-semibold text-lg">
                                        Groups
                                    </div>
                                    {admin && (
                                        <div className="text-ink-muted text-sm mb-5">
                                            Assign members to groups for better team organization.
                                        </div>
                                    )}
                                    <div className="flex">
                                        { Boolean(groupsArray.length) &&  manageGroupsTrigger}

                                    </div>
                                </div>

                                <div className="w-full">
                                    <div>
                                        { Boolean(groupsArray.length) &&   <div className="px-8 py-3 border-y w-full text-xs font-semibold border-line">
                                            Groups
                                        </div> }
                                        <table className="w-full">
                                            <tbody>
                                            {groupsArray.length ? <tr className="w-full">
                                                {watch('groups')?.map((group: any, index: number) => {
                                                    const groups = watch('groups') || [];
                                                    return (
                                                        <td
                                                            key={index}
                                                            className={`flex gap-3 items-center pl-8 py-4 ${
                                                                index !== groups.length - 1 ? 'border-b border-line' : ''
                                                            }`}
                                                        >
                                                            <PhoneHQIconAvatar icon={group?.icon} color={group?.iconColor ?? 'default'} size="32px"/>
                                                            {group.name}
                                                        </td>
                                                    );
                                                })}
                                            </tr> : (
                                                <div className={'justify-center flex my-[53px]'}>
                                                    <PhoneHQButton variant="secondary" size="sm" disabled={usersData?.status === "DELETED"} onClick={() => setOpenDialog('groups') } className="w-[300px] h-[50px]" phq-id='teamAdmin-assignUserToGroupBtn' >Assign a user to a group</PhoneHQButton>
                                                </div>

                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* Phone numbers section */}
                            <div className={`flex border-b ${isMobile ? 'mt-6' : ''} border-line`}>
                                <div className="border-r border-line px-8 py-5 lg:min-w-[180px] lg:w-[180px] xl:min-w-[280px] 2xl:min-w-[345px]">
                                    <div className="font-semibold text-lg">
                                        Phone numbers
                                    </div>
                                    <div className="text-ink-muted text-sm mb-5">
                                        Assign phone numbers to team members for internal and external calls.
                                    </div>
                                    <div>
                                        {Boolean(phoneNumbersArray.length) && managePhoneNumbersTrigger}
                                    </div>
                                </div>

                                <div className="w-full">
                                    {Boolean(phoneNumbersArray.length) &&   <div className="px-8 py-3 border-y w-full text-xs font-semibold border-line">
                                        Phone numbers
                                    </div>}
                                    <table className="w-full">
                                        <tbody>
                                        {/* Display phone numbers if available */}
                                        {phoneNumbersArray.length > 0 ? (
                                            watch('phoneNumbers').map((item:Msisdn, index: number) => (
                                                <tr
                                                    key={index}
                                                    className={index !== watch('phoneNumbers').length - 1 ? "border-b border-line" : ""}
                                                >
                                                    <td className="flex gap-3 items-center pl-8 py-4">
                                                        <div className="text-3xl">
                                                            <PhoneHQIconAvatar icon={item.icon} color={item.iconColor || Colors.default} size="32px"/>
                                                        </div>
                                                        {item.label}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr className={'justify-center flex my-[53px]'}>
                                                <PhoneHQButton variant="secondary" size="sm" disabled={usersData?.status === "DELETED"} onClick={() => setOpenDialog('numbers') } className="w-[300px] h-[50px]" phq-id='teamAdmin-addNumberModalOpenBtn' >Assign a user to a phone number</PhoneHQButton>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Action buttons */}
                    {admin && (
                        <div className={isMobile ? 'px-4' : ''}>
                            <div className={`m-8 ml-0 pb-8 flex ${isNewUser ? 'justify-end' : 'justify-between'}`}>
                                {(!isNewUser && usersData?.status !== 'DELETED' ) && (
                                    <div>
                                        <PhoneHQButton variant="text-danger" size="lg" onClick={()=> setOpenDialog('deactivate')} phq-id='teamAdmin-removeUserModalOpenBtn' ><PhoneHQGlyph name='delete' size={16}/>Deactivate</PhoneHQButton>
                                    </div>
                                )}
                                {(!isNewUser && usersData?.status == 'DELETED' ) && (
                                    <div>
                                        <PhoneHQButton variant="text" size="lg" onClick={()=> setOpenDialog('activate')} phq-id='teamAdmin-enableUSerModalOpenBtn' >Restore user</PhoneHQButton>
                                    </div>
                                )}
                                <div className="flex gap-4">
                                    <Link to="/admin/team">
                                        <PhoneHQButton variant="secondary" size="lg" phq-id='teamAdmin-goToListBtn' >Cancel</PhoneHQButton>
                                    </Link>
                                    <PhoneHQButton size="lg" onClick={handleSubmit(onSubmit, handleValidationErrors)} phq-id={isNewUser ? 'teamAdmin-inviteNewUserBtn' : 'teamAdmin-editUserBtn'}>{isNewUser ? 'Invite new team member' : 'Done'}</PhoneHQButton>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
            }
            {/* Group assignment modal */}
            {/* Each dialog reports Done/Cancel to its handler as before (true / false). */}
            <TeamDialog open={openDialog === 'groups'} title="Assign a user to a group" confirmLabel="Done"
                        onClose={(confirmed) => { setOpenDialog(null); handleAddGroups(confirmed); }}>
                {addGroupsModal}
            </TeamDialog>
            <TeamDialog open={openDialog === 'numbers'} title="Assign a user to phone numbers" confirmLabel="Done"
                        onClose={(confirmed) => { setOpenDialog(null); handleAddPhoneNumbers(confirmed); }}>
                {addPhoneNumberModal}
            </TeamDialog>
            <PhoneHQConfirmDialog open={openDialog === 'deactivate'} onOpenChange={(open) => !open && setOpenDialog(null)}
                                  title="Confirm deactivation" cancelLabel="Cancel" confirmLabel="Deactivate" tone="danger"
                                  onConfirm={() => { setOpenDialog(null); deactivateUser(true); }}>
                Are you sure you want to deactivate this user?
            </PhoneHQConfirmDialog>
            <PhoneHQConfirmDialog open={openDialog === 'activate'} onOpenChange={(open) => !open && setOpenDialog(null)}
                                  title="Confirm activation" cancelLabel="Cancel" confirmLabel="Activate"
                                  onConfirm={() => { setOpenDialog(null); activateUser(true); }}>
                Are you sure you want to enable this user?
            </PhoneHQConfirmDialog>
        
            </>
    );
}

/** Assign groups / numbers: body from the page, Cancel and Done report false / true. */
const TeamDialog = ({open, title, confirmLabel, onClose, children}: {
    open: boolean;
    title: string;
    confirmLabel: string;
    onClose: (confirmed: boolean) => void;
    children: React.ReactNode;
}) => (
    <PhoneHQModal
        open={open}
        onOpenChange={(next) => !next && onClose(false)}
        title={title}
        width={480}
        footer={
            <>
                <PhoneHQButton variant="secondary" className="px-5" onClick={() => onClose(false)}>Cancel</PhoneHQButton>
                <PhoneHQButton className="px-5" onClick={() => onClose(true)}>{confirmLabel}</PhoneHQButton>
            </>
        }
    >
        {children}
    </PhoneHQModal>
);
